const initialState = {};
export const stateLoader = () => ({
  ...initialState,
  catalog: {
    academicYears: [],
    months: [],
    specialists: [],
    activities: [],
    centers: [],
    providers: [],
    serviceLocations: [],
  },
  finilazedBillingStatus: {},
  filter: {
    academicYear: null,
    month: null,
    specialist: null,
    activity: null,
    center: null,
    provider: null,
    serviceLocation: null,
  },
  trainingSearchResults: {
    data: [],
    pagination: {
      currentPage: 0,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
    },
    paginationConfig: {
      initialCurrentPage: 1,
      initialPageSize: 10,
    },
  },
});

export default stateLoader();
